<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>增值税减免税申报明细表</dt>

      <dd>
        <div>纳税人名称（公章）：{{ staticConfig.companyName }}<br />（一般纳税人）</div>

        <div>税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}</div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table>
        <tbody class="read-mode">
          <tr>
            <td colspan="8">
              <b>一、减税项目</b>
            </td>
          </tr>
          <tr>
            <td rowspan="2" style="width: 250px">减税性质代码及名称</td>
            <td style="width: 50px">栏次</td>
            <td style="width: 140px">期初余额</td>
            <td style="width: 140px">本期发生额</td>
            <td style="width: 140px">本期应抵减税额</td>
            <td style="width: 140px" colspan="2">本期实际抵减税额</td>
            <td style="width: 140px">期末余额</td>
          </tr>
          <tr>
            <td></td>
            <td>1</td>
            <td>2</td>
            <td>3=1+2</td>
            <td colspan="2">4≤3</td>
            <td>5=3-4</td>
          </tr>
          <tr>
            <td>合计</td>
            <td>1</td>
            <td>{{ parseFloatNum(data.v1x1.value) }}</td>
            <td>{{ parseFloatNum(data.v1x2.value) }}</td>
            <td>{{ parseFloatNum(data.v1x3.value) }}</td>
            <td colspan="2">{{ parseFloatNum(data.v1x4.value) }}</td>
            <td>{{ parseFloatNum(data.v1x5.value) }}</td>
          </tr>
          <tr>
            <td>
              <el-select v-model="data.v2x6.value">
                <el-option v-for="(item, index) of options1" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>2</td>
            <td>
              <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x3.value) }}</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v2x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x5.value) }}</td>
          </tr>
          <tr>
            <td>
              <el-select v-model="data.v3x6.value">
                <el-option v-for="(item, index) of options1" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>3</td>
            <td>
              <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x3.value) }}</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v3x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x5.value) }}</td>
          </tr>
          <tr>
            <td>
              <el-select v-model="data.v4x6.value">
                <el-option v-for="(item, index) of options1" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>4</td>
            <td>
              <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v4x3.value) }}</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v4x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v4x5.value) }}</td>
          </tr>
          <tr>
            <td>
              <el-select v-model="data.v5x6.value">
                <el-option v-for="(item, index) of options1" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>5</td>
            <td>
              <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v5x3.value) }}</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v5x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v5x5.value) }}</td>
          </tr>
          <tr>
            <td>
              <el-select v-model="data.v6x6.value">
                <el-option v-for="(item, index) of options1" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>6</td>
            <td>
              <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v6x3.value) }}</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v6x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v6x5.value) }}</td>
          </tr>
          <tr id="row_js_after">
            <td colspan="8">
              <b>二、免税项目</b>
            </td>
          </tr>
          <tr>
            <td rowspan="2">免税性质代码及名称</td>
            <td></td>
            <td>免征增值税项目销售额</td>
            <td>免税销售额扣除项目本期实际扣除金额</td>
            <td>扣除后免税销售额</td>
            <td>免税销售额对应的进项税额</td>
            <td rowspan="2">适用税率</td>
            <td>免税额</td>
          </tr>
          <tr>
            <td></td>
            <td>1</td>
            <td>2</td>
            <td>3=1-2</td>
            <td>4</td>
            <td>5</td>
          </tr>
          <tr>
            <td>合计<input type="hidden" name="detail[1][num1]9" value="HJ_MS" /></td>
            <td>7</td>
            <td>{{ parseFloatNum(data.v7x1.value) }}</td>
            <td>{{ parseFloatNum(data.v7x2.value) }}</td>
            <td>{{ parseFloatNum(data.v7x3.value) }}</td>
            <td>--</td>
            <td>--</td>
            <td>{{ parseFloatNum(data.v7x5.value) }}</td>
          </tr>
          <tr id="rowid_2" class="row_ms_ckms">
            <td>出口免税<input type="hidden" name="R2TD29" value="MS_CKMS" /></td>
            <td>8</td>
            <td>
              <el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr id="rowid_3" class="row_ms_ckms">
            <td>其中：跨境服务<input type="hidden" name="R3TD29" value="MS_CKMS_KJFW" /></td>
            <td>9</td>
            <td>
              <el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr id="rowid_4" class="dynamic_row_js">
            <td>
              <el-select v-model="data.v10x6.value">
                <el-option v-for="(item, index) of options2" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>10</td>
            <td>
              <el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v10x3.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v10x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>--</td>
            <td>
              <el-input-number v-model.trim="data.v10x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr id="rowid_4" class="dynamic_row_js">
            <td>
              <el-select v-model="data.v11x6.value">
                <el-option v-for="(item, index) of options2" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>11</td>
            <td>
              <el-input-number v-model.trim="data.v11x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v11x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v11x3.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v11x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>--</td>
            <td>
              <el-input-number v-model.trim="data.v11x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr id="rowid_4" class="dynamic_row_js">
            <td>
              <el-select v-model="data.v12x6.value">
                <el-option v-for="(item, index) of options2" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>12</td>
            <td>
              <el-input-number v-model.trim="data.v12x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v12x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v12x3.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v12x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>--</td>
            <td>
              <el-input-number v-model.trim="data.v12x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr id="rowid_4" class="dynamic_row_js">
            <td>
              <el-select v-model="data.v13x6.value">
                <el-option v-for="(item, index) of options2" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>13</td>
            <td>
              <el-input-number v-model.trim="data.v13x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v13x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v13x3.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v13x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>--</td>
            <td>
              <el-input-number v-model.trim="data.v13x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr id="rowid_4" class="dynamic_row_js">
            <td>
              <el-select v-model="data.v14x6.value">
                <el-option v-for="(item, index) of options2" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>14</td>
            <td>
              <el-input-number v-model.trim="data.v14x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v14x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v14x3.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v14x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0</td>
            <td>
              <el-input-number v-model.trim="data.v14x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

// 选择框配置1
const options1 = [
  { value: "0", label: "请选择" },
  { value: "1011604", label: "1011604 | 《财政部 海关总署 国家税务总局关于支持芦山地震灾后恢复重建有关税收政策问题的通知》 财税〔2013〕58号" },
  {
    value: "1013602",
    label: "1013602 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 （财税〔2013〕106号）附件3《营业税改征增值税试点过渡政策的规定》第一条第（十三）项",
  },
  {
    value: "1013603",
    label: "1013603 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第1目",
  },
  {
    value: "1013604",
    label: "1013604 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第2目",
  },
  { value: "1129902", label: "1129902 | 《财政部 国家税务总局关于部分货物适用增值税低税率和简易办法征收增值税政策的通知》 财税〔2009〕9号" },
  { value: "1129914", label: "1129914 | 《财政部 国家税务总局关于增值税税控系统专用设备和技术维护费用抵减增值税税额有关政策的通知》 财税〔2012〕15号" },
  { value: "1129917", label: "1129917 | 《财政部 国家税务总局关于推广税控收款机有关税收政策的通知》 财税〔2004〕167号第一条、第二条、第三条" },
  { value: "1129924", label: "1129924 | 《财政部 国家税务总局关于简并增值税征收率政策的通知》 财税〔2014〕57号第一条" },
];

// 选择配置2
const options2 = [
  { value: "0", label: "请选择" },
  { value: "1010503", label: "《财政部 国家税务总局关于免征部分鲜活肉蛋产品流通环节增值税政策的通知》 财税〔2012〕75号" },
  { value: "1010504", label: "《财政部 国家税务总局关于免征蔬菜流通环节增值税有关问题的通知》 财税〔2011〕137号" },
  { value: "1011606", label: "《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号" },
  { value: "1011802", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1011803", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1011804", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1012707", label: "《中华人民共和国增值税暂行条例》 中华人民共和国国务院令第538号" },
  { value: "1019902", label: "《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号" },
  { value: "1019904", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1019905", label: "《财政部 国家税务总局关于免征储备大豆增值税政策的通知》 财税〔2014〕38号" },
  { value: "1019906", label: "《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号" },
  { value: "1021202", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1023002", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1032102", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1064001", label: "《财政部 国家税务总局关于促进节能服务产业发展增值税营业税和企业所得税政策问题的通知》 财税〔2010〕110号" },
  { value: "1064007", label: "《财政部 国家税务总局关于污水处理费有关增值税政策的通知》 财税〔2001〕97号" },
  { value: "1069901", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1081501", label: "《财政部 国家税务总局关于被撤销金融机构有关税收政策问题的通知》 财税〔2003〕141号" },
  { value: "1081502", label: "《财政部 国家税务总局关于黄金期货交易有关税收政策的通知》 财税〔2008〕5号" },
  { value: "1081503", label: "《财政部 国家税务总局关于上海期货交易所开展期货保税交割业务有关增值税问题的通知》 财税〔2010〕108号" },
  { value: "1081505", label: "《财政部 海关总署 国家税务总局关于调整钻石及上海钻石交易所有关税收政策的通知》 财税〔2006〕65号" },
  { value: "1081506", label: "《财政部 国家税务总局关于原油和铁矿石期货保税交割业务增值税政策的通知》 财税〔2015〕35号" },
  { value: "1083907", label: "《财政部 国家税务总局关于熊猫普制金币免征增值税政策的通知》 财税〔2012〕97号" },
  { value: "1083911", label: "《财政部 国家税务总局关于中国信达资产管理股份有限公司等4家金融资产管理公司有关税收政策问题的通知》 财税〔2013〕56号" },
  { value: "1092202", label: "《财政部 国家税务总局关于饲料产品免征增值税问题的通知》 财税〔2001〕121号" },
  { value: "1092301", label: "《财政部 国家税务总局关于不带动力的手扶拖拉机和三轮农用运输车增值税政策的通知》 财税〔2002〕89号" },
  { value: "1092303", label: "《财政部 国家税务总局关于免征农村电网维护费增值税问题的通知》 财税字〔1998〕47号" },
  { value: "1092304", label: "《财政部 国家税务总局关于农业生产资料征免增值税政策的通知》 财税〔2001〕113号" },
  { value: "1092309", label: "《财政部 国家税务总局关于支持农村饮水安全工程建设运营税收政策的通知》 财税〔2012〕30号" },
  { value: "1092310", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1092311", label: "《财政部 国家税务总局关于农民专业合作社有关税收政策的通知》 财税〔2008〕81号" },
  { value: "1099901", label: "《财政部 国家税务总局关于免征滴灌带和滴灌管产品增值税的通知》 财税〔2007〕83号" },
  { value: "1101401", label: "《财政部 国家税务总局关于教育税收政策的通知》财税〔2004〕39号" },
  { value: "1103220", label: "《财政部 国家税务总局关于延续宣传文化增值税和营业税优惠政策的通知》财税〔2013〕87号" },
  { value: "1103224", label: "《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号" },
  { value: "1103225", label: "《财政部 国家税务总局 中宣部关于继续实施文化体制改革中经营性文化事业单位转制为企业若干税收政策的通知》 财税〔2014〕84号" },
  { value: "1103226", label: "《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号" },
  { value: "1121301", label: "《财政部 国家税务总局关于铁路货车修理免征增值税的通知》 财税〔2001〕54号" },
  { value: "1124302", label: "《财政部 国家税务总局外经贸部关于外国政府和国际组织无偿援助项目在华采购物资免征增值税问题的通知》 财税〔2002〕2号" },
  { value: "1129907", label: "《财政部 国家税务总局关于黄金税收政策问题的通知》 财税〔2002〕142号" },
  { value: "1129911", label: "《国家税务总局关于拍卖行取得的拍卖收入征收增值税、营业税有关问题的通知》 国税发〔1999〕40号" },
  { value: "1129916", label: "《财政部 国家税务总局 中国人民银行关于配售出口黄金有关税收规定的通知》 财税〔2000〕3号" },
  { value: "1129920", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1129926", label: "《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号" },
  { value: "1129927", label: "《财政部 国家税务总局关于全面推开营业税改征增值税试点的通知》财税〔2016〕36号" },
  { value: "0001120604", label: "《财政部 税务总局关于支持新型冠状病毒感染的肺炎疫情防控有关税收政策的公告》财政部 税务总局公告2020年第8号" },
  { value: "0001120605", label: "《财政部 税务总局关于增值税小规模纳税人减免增值税政策的公告》财政部 税务总局公告2023年第19号" },
  { value: "1129999", label: "其他——" },
];

function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 1-6行
        for (let row = 1; row <= 6; row++) {
          // 3=1+2
          data.value[`v${row}x3`].value = new Big(data.value[`v${row}x1`].value).plus(data.value[`v${row}x2`].value).round(2).toNumber();
          // 5=3-4
          data.value[`v${row}x5`].value = new Big(data.value[`v${row}x3`].value).minus(data.value[`v${row}x4`].value).round(2).toNumber();
        }
        // 1,2,4列
        [1, 2, 4].forEach((column) => {
          data.value[`v1x${column}`].value = new Big(data.value[`v2x${column}`].value)
            .plus(data.value[`v3x${column}`].value)
            .plus(data.value[`v4x${column}`].value)
            .plus(data.value[`v5x${column}`].value)
            .plus(data.value[`v6x${column}`].value)
            .round(2)
            .toNumber();
        });
        // 7-14行
        for (let row = 7; row <= 14; row++) {
          // 3=1-2
          data.value[`v${row}x3`].value = new Big(data.value[`v${row}x1`].value).minus(data.value[`v${row}x2`].value).round(2).toNumber();
        }
        // 1-5列
        for (let column = 1; column <= 5; column++) {
          data.value[`v7x${column}`].value = new Big(data.value[`v8x${column}`].value)
            .plus(data.value[`v9x${column}`].value)
            .plus(data.value[`v10x${column}`].value)
            .plus(data.value[`v11x${column}`].value)
            .plus(data.value[`v12x${column}`].value)
            .plus(data.value[`v13x${column}`].value)
            .plus(data.value[`v14x${column}`].value)
            .round(2)
            .toNumber();
        }
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss"></style>

<script>
const tableHtml = `
<table>
  <tbody class="read-mode">
    <tr>
      <td colspan="8">
        <div class="td_align td_height"><b>一、减税项目</b></div>
      </td>
    </tr>
    <tr>
      <td rowspan="2"><div class="td_align">减税性质代码及名称</div></td>
      <td style="width: 80px"><div class="td_align">栏次</div></td>
      <td><div class="td_align td_height">期初余额</div></td>
      <td><div class="td_align">本期发生额</div></td>
      <td><div class="td_align">本期应抵减税额</div></td>
      <td colspan="2"><div class="td_align">本期实际抵减税额</div></td>
      <td><div class="td_align td_height">期末余额</div></td>
    </tr>
    <tr>
      <td><div class="td_align"></div></td>
      <td><div class="td_align td_height">1</div></td>
      <td><div class="td_align td_height">2</div></td>
      <td><div class="td_align">3=1+2</div></td>
      <td colspan="2"><div class="td_align">4≤3</div></td>
      <td><div class="td_align">5=3-4</div></td>
    </tr>
    <tr>
      <td style="width: 350px"><div class="td_align td_height">合计</div></td>
      <td><div class="td_align">1</div></td>
      <td style="width: 120px">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td style="width: 120px">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td style="width: 120px">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="2" style="width: 120px">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td style="width: 120px">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td>
        <div validate="data_2_1">
          <select>
            <option value="0" selected="selected">请选择</option>
            <option value="1011604">1011604 | 《财政部 海关总署 国家税务总局关于支持芦山地震灾后恢复重建有关税收政策问题的通知》 财税〔2013〕58号</option>
            <option value="1013602">
              1013602 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 （财税〔2013〕106号）附件3《营业税改征增值税试点过渡政策的规定》第一条第（十三）项
            </option>
            <option value="1013603">
              1013603 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第1目
            </option>
            <option value="1013604">
              1013604 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第2目
            </option>
            <option value="1129902">1129902 | 《财政部 国家税务总局关于部分货物适用增值税低税率和简易办法征收增值税政策的通知》 财税〔2009〕9号</option>
            <option value="1129914">1129914 | 《财政部 国家税务总局关于增值税税控系统专用设备和技术维护费用抵减增值税税额有关政策的通知》 财税〔2012〕15号</option>
            <option value="1129917">1129917 | 《财政部 国家税务总局关于推广税控收款机有关税收政策的通知》 财税〔2004〕167号第一条、第二条、第三条</option>
            <option value="1129924">1129924 | 《财政部 国家税务总局关于简并增值税征收率政策的通知》 财税〔2014〕57号第一条</option>
          </select>
        </div>
      </td>
      <td><div class="td_align">2</div></td>
      <td>
        <div validate="data_2_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="2">
        <div validate="data_2_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td>
        <div validate="data_3_1">
          <select>
            <option value="0" selected="selected">请选择</option>
            <option value="1011604">1011604 | 《财政部 海关总署 国家税务总局关于支持芦山地震灾后恢复重建有关税收政策问题的通知》 财税〔2013〕58号</option>
            <option value="1013602">
              1013602 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 （财税〔2013〕106号）附件3《营业税改征增值税试点过渡政策的规定》第一条第（十三）项
            </option>
            <option value="1013603">
              1013603 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第1目
            </option>
            <option value="1013604">
              1013604 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第2目
            </option>
            <option value="1129902">1129902 | 《财政部 国家税务总局关于部分货物适用增值税低税率和简易办法征收增值税政策的通知》 财税〔2009〕9号</option>
            <option value="1129914">1129914 | 《财政部 国家税务总局关于增值税税控系统专用设备和技术维护费用抵减增值税税额有关政策的通知》 财税〔2012〕15号</option>
            <option value="1129917">1129917 | 《财政部 国家税务总局关于推广税控收款机有关税收政策的通知》 财税〔2004〕167号第一条、第二条、第三条</option>
            <option value="1129924">1129924 | 《财政部 国家税务总局关于简并增值税征收率政策的通知》 财税〔2014〕57号第一条</option>
          </select>
        </div>
      </td>
      <td><div class="td_align">3</div></td>
      <td>
        <div validate="data_3_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="2">
        <div validate="data_3_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td>
        <div validate="data_4_1">
          <select>
            <option value="0" selected="selected">请选择</option>
            <option value="1011604">1011604 | 《财政部 海关总署 国家税务总局关于支持芦山地震灾后恢复重建有关税收政策问题的通知》 财税〔2013〕58号</option>
            <option value="1013602">
              1013602 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 （财税〔2013〕106号）附件3《营业税改征增值税试点过渡政策的规定》第一条第（十三）项
            </option>
            <option value="1013603">
              1013603 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第1目
            </option>
            <option value="1013604">
              1013604 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第2目
            </option>
            <option value="1129902">1129902 | 《财政部 国家税务总局关于部分货物适用增值税低税率和简易办法征收增值税政策的通知》 财税〔2009〕9号</option>
            <option value="1129914">1129914 | 《财政部 国家税务总局关于增值税税控系统专用设备和技术维护费用抵减增值税税额有关政策的通知》 财税〔2012〕15号</option>
            <option value="1129917">1129917 | 《财政部 国家税务总局关于推广税控收款机有关税收政策的通知》 财税〔2004〕167号第一条、第二条、第三条</option>
            <option value="1129924">1129924 | 《财政部 国家税务总局关于简并增值税征收率政策的通知》 财税〔2014〕57号第一条</option>
          </select>
        </div>
      </td>
      <td><div class="td_align">4</div></td>
      <td>
        <div validate="data_4_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="2">
        <div validate="data_4_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td>
        <div validate="data_5_1">
          <select>
            <option value="0" selected="selected">请选择</option>
            <option value="1011604">1011604 | 《财政部 海关总署 国家税务总局关于支持芦山地震灾后恢复重建有关税收政策问题的通知》 财税〔2013〕58号</option>
            <option value="1013602">
              1013602 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 （财税〔2013〕106号）附件3《营业税改征增值税试点过渡政策的规定》第一条第（十三）项
            </option>
            <option value="1013603">
              1013603 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第1目
            </option>
            <option value="1013604">
              1013604 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第2目
            </option>
            <option value="1129902">1129902 | 《财政部 国家税务总局关于部分货物适用增值税低税率和简易办法征收增值税政策的通知》 财税〔2009〕9号</option>
            <option value="1129914">1129914 | 《财政部 国家税务总局关于增值税税控系统专用设备和技术维护费用抵减增值税税额有关政策的通知》 财税〔2012〕15号</option>
            <option value="1129917">1129917 | 《财政部 国家税务总局关于推广税控收款机有关税收政策的通知》 财税〔2004〕167号第一条、第二条、第三条</option>
            <option value="1129924">1129924 | 《财政部 国家税务总局关于简并增值税征收率政策的通知》 财税〔2014〕57号第一条</option>
          </select>
        </div>
      </td>
      <td><div class="td_align">5</div></td>
      <td>
        <div validate="data_5_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="2">
        <div validate="data_5_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td>
        <div validate="data_6_1">
          <select>
            <option value="0" selected="selected">请选择</option>
            <option value="1011604">1011604 | 《财政部 海关总署 国家税务总局关于支持芦山地震灾后恢复重建有关税收政策问题的通知》 财税〔2013〕58号</option>
            <option value="1013602">
              1013602 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 （财税〔2013〕106号）附件3《营业税改征增值税试点过渡政策的规定》第一条第（十三）项
            </option>
            <option value="1013603">
              1013603 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第1目
            </option>
            <option value="1013604">
              1013604 | 《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号 《附件3.营业税改征增值税试点过渡政策的规定》第一条第（十三）项第2目
            </option>
            <option value="1129902">1129902 | 《财政部 国家税务总局关于部分货物适用增值税低税率和简易办法征收增值税政策的通知》 财税〔2009〕9号</option>
            <option value="1129914">1129914 | 《财政部 国家税务总局关于增值税税控系统专用设备和技术维护费用抵减增值税税额有关政策的通知》 财税〔2012〕15号</option>
            <option value="1129917">1129917 | 《财政部 国家税务总局关于推广税控收款机有关税收政策的通知》 财税〔2004〕167号第一条、第二条、第三条</option>
            <option value="1129924">1129924 | 《财政部 国家税务总局关于简并增值税征收率政策的通知》 财税〔2014〕57号第一条</option>
          </select>
        </div>
      </td>
      <td><div class="td_align">6</div></td>
      <td>
        <div validate="data_6_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_6_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="2">
        <div validate="data_6_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr id="row_js_after">
      <td colspan="8">
        <div class="td_align td_height"><b>二、免税项目</b></div>
      </td>
    </tr>
    <tr>
      <td rowspan="2"><div class="td_align">免税性质代码及名称</div></td>
      <td><div class="td_align"></div></td>
      <td><div class="td_align">免征增值税项目销售额</div></td>
      <td><div class="td_align">免税销售额扣除项目本期实际扣除金额</div></td>
      <td><div class="td_align">扣除后免税销售额</div></td>
      <td><div class="td_align">免税销售额对应的进项税额</div></td>
      <td rowspan="2"><div class="td_align">适用税率</div></td>
      <td><div class="td_align td_height">免税额</div></td>
    </tr>
    <tr>
      <td><div class="td_align"></div></td>
      <td><div class="td_align td_height">1</div></td>
      <td><div class="td_align td_height">2</div></td>
      <td><div class="td_align">3=1-2</div></td>
      <td><div class="td_align">4</div></td>
      <td><div class="td_align">5</div></td>
    </tr>
    <tr>
      <td>
        <div class="td_align td_height">合计<input type="hidden" name="detail[1][num1]9" value="HJ_MS" /></div>
      </td>
      <td><div class="td_align">7</div></td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">--</div></td>
      <td><div class="grid-nocontent">--</div></td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr id="rowid_2" class="row_ms_ckms">
      <td>
        <div class="td_align td_height">出口免税<input type="hidden" name="R2TD29" value="MS_CKMS" /></div>
      </td>
      <td><div class="td_align">8</div></td>
      <td>
        <div validate="data_8_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">--</div></td>
      <td><div class="grid-nocontent">--</div></td>
      <td><div class="grid-nocontent">--</div></td>
      <td><div class="grid-nocontent">--</div></td>
      <td><div class="grid-nocontent">--</div></td>
    </tr>
    <tr id="rowid_3" class="row_ms_ckms">
      <td>
        <div class="td_align td_height">其中：跨境服务<input type="hidden" name="R3TD29" value="MS_CKMS_KJFW" /></div>
      </td>
      <td><div class="td_align">9</div></td>
      <td>
        <div validate="data_9_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">--</div></td>
      <td><div class="grid-nocontent">--</div></td>
      <td><div class="grid-nocontent">--</div></td>
      <td><div class="grid-nocontent">--</div></td>
      <td><div class="grid-nocontent">--</div></td>
    </tr>
    <tr id="rowid_4" class="dynamic_row_js">
      <td>
        <div validate="data_10_1">
          <select>
            <option value="0" selected="selected">请选择</option>
            <option value="1010503">《财政部 国家税务总局关于免征部分鲜活肉蛋产品流通环节增值税政策的通知》 财税〔2012〕75号</option>
            <option value="1010504">《财政部 国家税务总局关于免征蔬菜流通环节增值税有关问题的通知》 财税〔2011〕137号</option>
            <option value="1011606">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1011802">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1011803">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1011804">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1012707">《中华人民共和国增值税暂行条例》 中华人民共和国国务院令第538号</option>
            <option value="1019902">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1019904">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1019905">《财政部 国家税务总局关于免征储备大豆增值税政策的通知》 财税〔2014〕38号</option>
            <option value="1019906">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1021202">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1023002">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1032102">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1064001">《财政部 国家税务总局关于促进节能服务产业发展增值税营业税和企业所得税政策问题的通知》 财税〔2010〕110号</option>
            <option value="1064007">《财政部 国家税务总局关于污水处理费有关增值税政策的通知》 财税〔2001〕97号</option>
            <option value="1069901">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1081501">《财政部 国家税务总局关于被撤销金融机构有关税收政策问题的通知》 财税〔2003〕141号</option>
            <option value="1081502">《财政部 国家税务总局关于黄金期货交易有关税收政策的通知》 财税〔2008〕5号</option>
            <option value="1081503">《财政部 国家税务总局关于上海期货交易所开展期货保税交割业务有关增值税问题的通知》 财税〔2010〕108号</option>
            <option value="1081505">《财政部 海关总署 国家税务总局关于调整钻石及上海钻石交易所有关税收政策的通知》 财税〔2006〕65号</option>
            <option value="1081506">《财政部 国家税务总局关于原油和铁矿石期货保税交割业务增值税政策的通知》 财税〔2015〕35号</option>
            <option value="1083907">《财政部 国家税务总局关于熊猫普制金币免征增值税政策的通知》 财税〔2012〕97号</option>
            <option value="1083911">《财政部 国家税务总局关于中国信达资产管理股份有限公司等4家金融资产管理公司有关税收政策问题的通知》 财税〔2013〕56号</option>
            <option value="1092202">《财政部 国家税务总局关于饲料产品免征增值税问题的通知》 财税〔2001〕121号</option>
            <option value="1092301">《财政部 国家税务总局关于不带动力的手扶拖拉机和三轮农用运输车增值税政策的通知》 财税〔2002〕89号</option>
            <option value="1092303">《财政部 国家税务总局关于免征农村电网维护费增值税问题的通知》 财税字〔1998〕47号</option>
            <option value="1092304">《财政部 国家税务总局关于农业生产资料征免增值税政策的通知》 财税〔2001〕113号</option>
            <option value="1092309">《财政部 国家税务总局关于支持农村饮水安全工程建设运营税收政策的通知》 财税〔2012〕30号</option>
            <option value="1092310">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1092311">《财政部 国家税务总局关于农民专业合作社有关税收政策的通知》 财税〔2008〕81号</option>
            <option value="1099901">《财政部 国家税务总局关于免征滴灌带和滴灌管产品增值税的通知》 财税〔2007〕83号</option>
            <option value="1101401">《财政部 国家税务总局关于教育税收政策的通知》财税〔2004〕39号</option>
            <option value="1103220">《财政部 国家税务总局关于延续宣传文化增值税和营业税优惠政策的通知》财税〔2013〕87号</option>
            <option value="1103224">《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号</option>
            <option value="1103225">《财政部 国家税务总局 中宣部关于继续实施文化体制改革中经营性文化事业单位转制为企业若干税收政策的通知》 财税〔2014〕84号</option>
            <option value="1103226">《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号</option>
            <option value="1121301">《财政部 国家税务总局关于铁路货车修理免征增值税的通知》 财税〔2001〕54号</option>
            <option value="1124302">《财政部 国家税务总局外经贸部关于外国政府和国际组织无偿援助项目在华采购物资免征增值税问题的通知》 财税〔2002〕2号</option>
            <option value="1129907">《财政部 国家税务总局关于黄金税收政策问题的通知》 财税〔2002〕142号</option>
            <option value="1129911">《国家税务总局关于拍卖行取得的拍卖收入征收增值税、营业税有关问题的通知》 国税发〔1999〕40号</option>
            <option value="1129916">《财政部 国家税务总局 中国人民银行关于配售出口黄金有关税收规定的通知》 财税〔2000〕3号</option>
            <option value="1129920">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1129926">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1129927">《财政部 国家税务总局关于全面推开营业税改征增值税试点的通知》财税〔2016〕36号</option>
            <option value="0001120604">《财政部 税务总局关于支持新型冠状病毒感染的肺炎疫情防控有关税收政策的公告》财政部 税务总局公告2020年第8号</option>
            <option value="0001120605">《财政部 税务总局关于增值税小规模纳税人减免增值税政策的公告》财政部 税务总局公告2023年第19号</option>
            <option value="1129999">其他——</option>
          </select>
        </div>
      </td>
      <td><div class="td_align">10</div></td>
      <td>
        <div validate="data_10_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_10_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">--</div></td>
      <td>
        <div validate="data_10_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr id="rowid_4" class="dynamic_row_js">
      <td>
        <div validate="data_11_1">
          <select>
            <option value="0" selected="selected">请选择</option>
            <option value="1010503">《财政部 国家税务总局关于免征部分鲜活肉蛋产品流通环节增值税政策的通知》 财税〔2012〕75号</option>
            <option value="1010504">《财政部 国家税务总局关于免征蔬菜流通环节增值税有关问题的通知》 财税〔2011〕137号</option>
            <option value="1011606">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1011802">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1011803">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1011804">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1012707">《中华人民共和国增值税暂行条例》 中华人民共和国国务院令第538号</option>
            <option value="1019902">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1019904">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1019905">《财政部 国家税务总局关于免征储备大豆增值税政策的通知》 财税〔2014〕38号</option>
            <option value="1019906">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1021202">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1023002">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1032102">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1064001">《财政部 国家税务总局关于促进节能服务产业发展增值税营业税和企业所得税政策问题的通知》 财税〔2010〕110号</option>
            <option value="1064007">《财政部 国家税务总局关于污水处理费有关增值税政策的通知》 财税〔2001〕97号</option>
            <option value="1069901">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1081501">《财政部 国家税务总局关于被撤销金融机构有关税收政策问题的通知》 财税〔2003〕141号</option>
            <option value="1081502">《财政部 国家税务总局关于黄金期货交易有关税收政策的通知》 财税〔2008〕5号</option>
            <option value="1081503">《财政部 国家税务总局关于上海期货交易所开展期货保税交割业务有关增值税问题的通知》 财税〔2010〕108号</option>
            <option value="1081505">《财政部 海关总署 国家税务总局关于调整钻石及上海钻石交易所有关税收政策的通知》 财税〔2006〕65号</option>
            <option value="1081506">《财政部 国家税务总局关于原油和铁矿石期货保税交割业务增值税政策的通知》 财税〔2015〕35号</option>
            <option value="1083907">《财政部 国家税务总局关于熊猫普制金币免征增值税政策的通知》 财税〔2012〕97号</option>
            <option value="1083911">《财政部 国家税务总局关于中国信达资产管理股份有限公司等4家金融资产管理公司有关税收政策问题的通知》 财税〔2013〕56号</option>
            <option value="1092202">《财政部 国家税务总局关于饲料产品免征增值税问题的通知》 财税〔2001〕121号</option>
            <option value="1092301">《财政部 国家税务总局关于不带动力的手扶拖拉机和三轮农用运输车增值税政策的通知》 财税〔2002〕89号</option>
            <option value="1092303">《财政部 国家税务总局关于免征农村电网维护费增值税问题的通知》 财税字〔1998〕47号</option>
            <option value="1092304">《财政部 国家税务总局关于农业生产资料征免增值税政策的通知》 财税〔2001〕113号</option>
            <option value="1092309">《财政部 国家税务总局关于支持农村饮水安全工程建设运营税收政策的通知》 财税〔2012〕30号</option>
            <option value="1092310">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1092311">《财政部 国家税务总局关于农民专业合作社有关税收政策的通知》 财税〔2008〕81号</option>
            <option value="1099901">《财政部 国家税务总局关于免征滴灌带和滴灌管产品增值税的通知》 财税〔2007〕83号</option>
            <option value="1101401">《财政部 国家税务总局关于教育税收政策的通知》财税〔2004〕39号</option>
            <option value="1103220">《财政部 国家税务总局关于延续宣传文化增值税和营业税优惠政策的通知》财税〔2013〕87号</option>
            <option value="1103224">《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号</option>
            <option value="1103225">《财政部 国家税务总局 中宣部关于继续实施文化体制改革中经营性文化事业单位转制为企业若干税收政策的通知》 财税〔2014〕84号</option>
            <option value="1103226">《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号</option>
            <option value="1121301">《财政部 国家税务总局关于铁路货车修理免征增值税的通知》 财税〔2001〕54号</option>
            <option value="1124302">《财政部 国家税务总局外经贸部关于外国政府和国际组织无偿援助项目在华采购物资免征增值税问题的通知》 财税〔2002〕2号</option>
            <option value="1129907">《财政部 国家税务总局关于黄金税收政策问题的通知》 财税〔2002〕142号</option>
            <option value="1129911">《国家税务总局关于拍卖行取得的拍卖收入征收增值税、营业税有关问题的通知》 国税发〔1999〕40号</option>
            <option value="1129916">《财政部 国家税务总局 中国人民银行关于配售出口黄金有关税收规定的通知》 财税〔2000〕3号</option>
            <option value="1129920">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1129926">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1129927">《财政部 国家税务总局关于全面推开营业税改征增值税试点的通知》财税〔2016〕36号</option>
            <option value="0001120604">《财政部 税务总局关于支持新型冠状病毒感染的肺炎疫情防控有关税收政策的公告》财政部 税务总局公告2020年第8号</option>
            <option value="0001120605">《财政部 税务总局关于增值税小规模纳税人减免增值税政策的公告》财政部 税务总局公告2023年第19号</option>
            <option value="1129999">其他——</option>
          </select>
        </div>
      </td>
      <td><div class="td_align">11</div></td>
      <td>
        <div validate="data_11_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_11_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_11_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">--</div></td>
      <td>
        <div validate="data_11_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr id="rowid_4" class="dynamic_row_js">
      <td>
        <div validate="data_12_1">
          <select>
            <option value="0" selected="selected">请选择</option>
            <option value="1010503">《财政部 国家税务总局关于免征部分鲜活肉蛋产品流通环节增值税政策的通知》 财税〔2012〕75号</option>
            <option value="1010504">《财政部 国家税务总局关于免征蔬菜流通环节增值税有关问题的通知》 财税〔2011〕137号</option>
            <option value="1011606">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1011802">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1011803">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1011804">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1012707">《中华人民共和国增值税暂行条例》 中华人民共和国国务院令第538号</option>
            <option value="1019902">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1019904">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1019905">《财政部 国家税务总局关于免征储备大豆增值税政策的通知》 财税〔2014〕38号</option>
            <option value="1019906">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1021202">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1023002">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1032102">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1064001">《财政部 国家税务总局关于促进节能服务产业发展增值税营业税和企业所得税政策问题的通知》 财税〔2010〕110号</option>
            <option value="1064007">《财政部 国家税务总局关于污水处理费有关增值税政策的通知》 财税〔2001〕97号</option>
            <option value="1069901">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1081501">《财政部 国家税务总局关于被撤销金融机构有关税收政策问题的通知》 财税〔2003〕141号</option>
            <option value="1081502">《财政部 国家税务总局关于黄金期货交易有关税收政策的通知》 财税〔2008〕5号</option>
            <option value="1081503">《财政部 国家税务总局关于上海期货交易所开展期货保税交割业务有关增值税问题的通知》 财税〔2010〕108号</option>
            <option value="1081505">《财政部 海关总署 国家税务总局关于调整钻石及上海钻石交易所有关税收政策的通知》 财税〔2006〕65号</option>
            <option value="1081506">《财政部 国家税务总局关于原油和铁矿石期货保税交割业务增值税政策的通知》 财税〔2015〕35号</option>
            <option value="1083907">《财政部 国家税务总局关于熊猫普制金币免征增值税政策的通知》 财税〔2012〕97号</option>
            <option value="1083911">《财政部 国家税务总局关于中国信达资产管理股份有限公司等4家金融资产管理公司有关税收政策问题的通知》 财税〔2013〕56号</option>
            <option value="1092202">《财政部 国家税务总局关于饲料产品免征增值税问题的通知》 财税〔2001〕121号</option>
            <option value="1092301">《财政部 国家税务总局关于不带动力的手扶拖拉机和三轮农用运输车增值税政策的通知》 财税〔2002〕89号</option>
            <option value="1092303">《财政部 国家税务总局关于免征农村电网维护费增值税问题的通知》 财税字〔1998〕47号</option>
            <option value="1092304">《财政部 国家税务总局关于农业生产资料征免增值税政策的通知》 财税〔2001〕113号</option>
            <option value="1092309">《财政部 国家税务总局关于支持农村饮水安全工程建设运营税收政策的通知》 财税〔2012〕30号</option>
            <option value="1092310">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1092311">《财政部 国家税务总局关于农民专业合作社有关税收政策的通知》 财税〔2008〕81号</option>
            <option value="1099901">《财政部 国家税务总局关于免征滴灌带和滴灌管产品增值税的通知》 财税〔2007〕83号</option>
            <option value="1101401">《财政部 国家税务总局关于教育税收政策的通知》财税〔2004〕39号</option>
            <option value="1103220">《财政部 国家税务总局关于延续宣传文化增值税和营业税优惠政策的通知》财税〔2013〕87号</option>
            <option value="1103224">《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号</option>
            <option value="1103225">《财政部 国家税务总局 中宣部关于继续实施文化体制改革中经营性文化事业单位转制为企业若干税收政策的通知》 财税〔2014〕84号</option>
            <option value="1103226">《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号</option>
            <option value="1121301">《财政部 国家税务总局关于铁路货车修理免征增值税的通知》 财税〔2001〕54号</option>
            <option value="1124302">《财政部 国家税务总局外经贸部关于外国政府和国际组织无偿援助项目在华采购物资免征增值税问题的通知》 财税〔2002〕2号</option>
            <option value="1129907">《财政部 国家税务总局关于黄金税收政策问题的通知》 财税〔2002〕142号</option>
            <option value="1129911">《国家税务总局关于拍卖行取得的拍卖收入征收增值税、营业税有关问题的通知》 国税发〔1999〕40号</option>
            <option value="1129916">《财政部 国家税务总局 中国人民银行关于配售出口黄金有关税收规定的通知》 财税〔2000〕3号</option>
            <option value="1129920">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1129926">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1129927">《财政部 国家税务总局关于全面推开营业税改征增值税试点的通知》财税〔2016〕36号</option>
            <option value="0001120604">《财政部 税务总局关于支持新型冠状病毒感染的肺炎疫情防控有关税收政策的公告》财政部 税务总局公告2020年第8号</option>
            <option value="0001120605">《财政部 税务总局关于增值税小规模纳税人减免增值税政策的公告》财政部 税务总局公告2023年第19号</option>
            <option value="1129999">其他——</option>
          </select>
        </div>
      </td>
      <td><div class="td_align">12</div></td>
      <td>
        <div validate="data_12_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_12_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_12_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">--</div></td>
      <td>
        <div validate="data_12_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr id="rowid_4" class="dynamic_row_js">
      <td>
        <div validate="data_13_1">
          <select>
            <option value="0" selected="selected">请选择</option>
            <option value="1010503">《财政部 国家税务总局关于免征部分鲜活肉蛋产品流通环节增值税政策的通知》 财税〔2012〕75号</option>
            <option value="1010504">《财政部 国家税务总局关于免征蔬菜流通环节增值税有关问题的通知》 财税〔2011〕137号</option>
            <option value="1011606">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1011802">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1011803">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1011804">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1012707">《中华人民共和国增值税暂行条例》 中华人民共和国国务院令第538号</option>
            <option value="1019902">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1019904">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1019905">《财政部 国家税务总局关于免征储备大豆增值税政策的通知》 财税〔2014〕38号</option>
            <option value="1019906">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1021202">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1023002">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1032102">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1064001">《财政部 国家税务总局关于促进节能服务产业发展增值税营业税和企业所得税政策问题的通知》 财税〔2010〕110号</option>
            <option value="1064007">《财政部 国家税务总局关于污水处理费有关增值税政策的通知》 财税〔2001〕97号</option>
            <option value="1069901">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1081501">《财政部 国家税务总局关于被撤销金融机构有关税收政策问题的通知》 财税〔2003〕141号</option>
            <option value="1081502">《财政部 国家税务总局关于黄金期货交易有关税收政策的通知》 财税〔2008〕5号</option>
            <option value="1081503">《财政部 国家税务总局关于上海期货交易所开展期货保税交割业务有关增值税问题的通知》 财税〔2010〕108号</option>
            <option value="1081505">《财政部 海关总署 国家税务总局关于调整钻石及上海钻石交易所有关税收政策的通知》 财税〔2006〕65号</option>
            <option value="1081506">《财政部 国家税务总局关于原油和铁矿石期货保税交割业务增值税政策的通知》 财税〔2015〕35号</option>
            <option value="1083907">《财政部 国家税务总局关于熊猫普制金币免征增值税政策的通知》 财税〔2012〕97号</option>
            <option value="1083911">《财政部 国家税务总局关于中国信达资产管理股份有限公司等4家金融资产管理公司有关税收政策问题的通知》 财税〔2013〕56号</option>
            <option value="1092202">《财政部 国家税务总局关于饲料产品免征增值税问题的通知》 财税〔2001〕121号</option>
            <option value="1092301">《财政部 国家税务总局关于不带动力的手扶拖拉机和三轮农用运输车增值税政策的通知》 财税〔2002〕89号</option>
            <option value="1092303">《财政部 国家税务总局关于免征农村电网维护费增值税问题的通知》 财税字〔1998〕47号</option>
            <option value="1092304">《财政部 国家税务总局关于农业生产资料征免增值税政策的通知》 财税〔2001〕113号</option>
            <option value="1092309">《财政部 国家税务总局关于支持农村饮水安全工程建设运营税收政策的通知》 财税〔2012〕30号</option>
            <option value="1092310">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1092311">《财政部 国家税务总局关于农民专业合作社有关税收政策的通知》 财税〔2008〕81号</option>
            <option value="1099901">《财政部 国家税务总局关于免征滴灌带和滴灌管产品增值税的通知》 财税〔2007〕83号</option>
            <option value="1101401">《财政部 国家税务总局关于教育税收政策的通知》财税〔2004〕39号</option>
            <option value="1103220">《财政部 国家税务总局关于延续宣传文化增值税和营业税优惠政策的通知》财税〔2013〕87号</option>
            <option value="1103224">《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号</option>
            <option value="1103225">《财政部 国家税务总局 中宣部关于继续实施文化体制改革中经营性文化事业单位转制为企业若干税收政策的通知》 财税〔2014〕84号</option>
            <option value="1103226">《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号</option>
            <option value="1121301">《财政部 国家税务总局关于铁路货车修理免征增值税的通知》 财税〔2001〕54号</option>
            <option value="1124302">《财政部 国家税务总局外经贸部关于外国政府和国际组织无偿援助项目在华采购物资免征增值税问题的通知》 财税〔2002〕2号</option>
            <option value="1129907">《财政部 国家税务总局关于黄金税收政策问题的通知》 财税〔2002〕142号</option>
            <option value="1129911">《国家税务总局关于拍卖行取得的拍卖收入征收增值税、营业税有关问题的通知》 国税发〔1999〕40号</option>
            <option value="1129916">《财政部 国家税务总局 中国人民银行关于配售出口黄金有关税收规定的通知》 财税〔2000〕3号</option>
            <option value="1129920">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1129926">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1129927">《财政部 国家税务总局关于全面推开营业税改征增值税试点的通知》财税〔2016〕36号</option>
            <option value="0001120604">《财政部 税务总局关于支持新型冠状病毒感染的肺炎疫情防控有关税收政策的公告》财政部 税务总局公告2020年第8号</option>
            <option value="0001120605">《财政部 税务总局关于增值税小规模纳税人减免增值税政策的公告》财政部 税务总局公告2023年第19号</option>
            <option value="1129999">其他——</option>
          </select>
        </div>
      </td>
      <td><div class="td_align">13</div></td>
      <td>
        <div validate="data_13_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_13_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_13_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">--</div></td>
      <td>
        <div validate="data_13_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr id="rowid_4" class="dynamic_row_js">
      <td>
        <div validate="data_14_1">
          <select>
            <option value="0" selected="selected">请选择</option>
            <option value="1010503">《财政部 国家税务总局关于免征部分鲜活肉蛋产品流通环节增值税政策的通知》 财税〔2012〕75号</option>
            <option value="1010504">《财政部 国家税务总局关于免征蔬菜流通环节增值税有关问题的通知》 财税〔2011〕137号</option>
            <option value="1011606">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1011802">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1011803">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1011804">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1012707">《中华人民共和国增值税暂行条例》 中华人民共和国国务院令第538号</option>
            <option value="1019902">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1019904">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1019905">《财政部 国家税务总局关于免征储备大豆增值税政策的通知》 财税〔2014〕38号</option>
            <option value="1019906">《财政部 国家税务总局关于粮食企业增值税征免问题的通知》 财税字〔1999〕198号</option>
            <option value="1021202">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1023002">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1032102">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1064001">《财政部 国家税务总局关于促进节能服务产业发展增值税营业税和企业所得税政策问题的通知》 财税〔2010〕110号</option>
            <option value="1064007">《财政部 国家税务总局关于污水处理费有关增值税政策的通知》 财税〔2001〕97号</option>
            <option value="1069901">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1081501">《财政部 国家税务总局关于被撤销金融机构有关税收政策问题的通知》 财税〔2003〕141号</option>
            <option value="1081502">《财政部 国家税务总局关于黄金期货交易有关税收政策的通知》 财税〔2008〕5号</option>
            <option value="1081503">《财政部 国家税务总局关于上海期货交易所开展期货保税交割业务有关增值税问题的通知》 财税〔2010〕108号</option>
            <option value="1081505">《财政部 海关总署 国家税务总局关于调整钻石及上海钻石交易所有关税收政策的通知》 财税〔2006〕65号</option>
            <option value="1081506">《财政部 国家税务总局关于原油和铁矿石期货保税交割业务增值税政策的通知》 财税〔2015〕35号</option>
            <option value="1083907">《财政部 国家税务总局关于熊猫普制金币免征增值税政策的通知》 财税〔2012〕97号</option>
            <option value="1083911">《财政部 国家税务总局关于中国信达资产管理股份有限公司等4家金融资产管理公司有关税收政策问题的通知》 财税〔2013〕56号</option>
            <option value="1092202">《财政部 国家税务总局关于饲料产品免征增值税问题的通知》 财税〔2001〕121号</option>
            <option value="1092301">《财政部 国家税务总局关于不带动力的手扶拖拉机和三轮农用运输车增值税政策的通知》 财税〔2002〕89号</option>
            <option value="1092303">《财政部 国家税务总局关于免征农村电网维护费增值税问题的通知》 财税字〔1998〕47号</option>
            <option value="1092304">《财政部 国家税务总局关于农业生产资料征免增值税政策的通知》 财税〔2001〕113号</option>
            <option value="1092309">《财政部 国家税务总局关于支持农村饮水安全工程建设运营税收政策的通知》 财税〔2012〕30号</option>
            <option value="1092310">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1092311">《财政部 国家税务总局关于农民专业合作社有关税收政策的通知》 财税〔2008〕81号</option>
            <option value="1099901">《财政部 国家税务总局关于免征滴灌带和滴灌管产品增值税的通知》 财税〔2007〕83号</option>
            <option value="1101401">《财政部 国家税务总局关于教育税收政策的通知》财税〔2004〕39号</option>
            <option value="1103220">《财政部 国家税务总局关于延续宣传文化增值税和营业税优惠政策的通知》财税〔2013〕87号</option>
            <option value="1103224">《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号</option>
            <option value="1103225">《财政部 国家税务总局 中宣部关于继续实施文化体制改革中经营性文化事业单位转制为企业若干税收政策的通知》 财税〔2014〕84号</option>
            <option value="1103226">《财政部 海关总署 国家税务总局关于继续实施支持文化企业发展若干税收政策的通知》 财税〔2014〕85号</option>
            <option value="1121301">《财政部 国家税务总局关于铁路货车修理免征增值税的通知》 财税〔2001〕54号</option>
            <option value="1124302">《财政部 国家税务总局外经贸部关于外国政府和国际组织无偿援助项目在华采购物资免征增值税问题的通知》 财税〔2002〕2号</option>
            <option value="1129907">《财政部 国家税务总局关于黄金税收政策问题的通知》 财税〔2002〕142号</option>
            <option value="1129911">《国家税务总局关于拍卖行取得的拍卖收入征收增值税、营业税有关问题的通知》 国税发〔1999〕40号</option>
            <option value="1129916">《财政部 国家税务总局 中国人民银行关于配售出口黄金有关税收规定的通知》 财税〔2000〕3号</option>
            <option value="1129920">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1129926">《财政部 国家税务总局关于将铁路运输和邮政业纳入营业税改征增值税试点的通知》 财税〔2013〕106号</option>
            <option value="1129927">《财政部 国家税务总局关于全面推开营业税改征增值税试点的通知》财税〔2016〕36号</option>
            <option value="0001120604">《财政部 税务总局关于支持新型冠状病毒感染的肺炎疫情防控有关税收政策的公告》财政部 税务总局公告2020年第8号</option>
            <option value="0001120605">《财政部 税务总局关于增值税小规模纳税人减免增值税政策的公告》财政部 税务总局公告2023年第19号</option>
            <option value="1129999">其他——</option>
          </select>
        </div>
      </td>
      <td><div class="td_align">14</div></td>
      <td>
        <div validate="data_14_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_14_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_14_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">0</div></td>
      <td>
        <div validate="data_14_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
